var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_15528_149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.257 14.2857C13.3914 14.2876 13.5248 14.2627 13.6495 14.2126C13.7743 14.1625 13.8878 14.0881 13.9835 13.9937C14.0792 13.8993 14.1552 13.7869 14.207 13.6629C14.2589 13.5389 14.2856 13.4058 14.2856 13.2714V1.01438C14.2856 0.879969 14.2589 0.746899 14.207 0.622901C14.1552 0.498903 14.0792 0.38645 13.9835 0.292077C13.8878 0.197703 13.7743 0.123292 13.6495 0.0731686C13.5248 0.0230447 13.3914 -0.00179244 13.257 0.000100615H1.01428C0.745273 0.000100615 0.487288 0.106961 0.297074 0.297175C0.106861 0.487389 0 0.745373 0 1.01438L0 13.2714C0 13.5404 0.106861 13.7984 0.297074 13.9886C0.487288 14.1788 0.745273 14.2857 1.01428 14.2857H13.257Z",
    fill: "rgba(255, 255, 255, 0.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9712 5.71446H15.7141V14.5858C15.7141 14.734 15.6849 14.8808 15.6282 15.0177C15.5715 15.1546 15.4884 15.279 15.3836 15.3838C15.2788 15.4886 15.1544 15.5717 15.0175 15.6284C14.8805 15.6852 14.7338 15.7144 14.5856 15.7144H5.71423V18.9858C5.71422 19.1202 5.74092 19.2532 5.79278 19.3772C5.84465 19.5012 5.92064 19.6137 6.01634 19.708C6.11204 19.8024 6.22555 19.8768 6.35026 19.927C6.47497 19.9771 6.6084 20.0019 6.74279 20H18.9855C19.2545 20 19.5125 19.8932 19.7027 19.703C19.8929 19.5127 19.9998 19.2548 19.9998 18.9858V6.72873C19.9998 6.59432 19.9731 6.46126 19.9213 6.33726C19.8694 6.21326 19.7934 6.10081 19.6977 6.00643C19.602 5.91206 19.4885 5.83765 19.3638 5.78752C19.2391 5.7374 19.1056 5.71256 18.9712 5.71446Z",
    fill: "rgba(255, 255, 255, 0.54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15528_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7dd4ef1e72f5c8c29303a7b101dc4ced.svg";
export { ForwardRef as ReactComponent };